import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyService } from 'src/app/api/services/company.service';
import { LoadingComponent } from 'src/app/shared/component/loading/loading.component';
import { TableGenericComponent } from 'src/app/shared/component/table-generic/table-generic.component';
import { CompanyAdmin } from 'src/app/shared/model/admin';

@Component({
  selector: 'app-package-admin',
  imports: [LoadingComponent, CommonModule, TableGenericComponent],
  templateUrl: './package-admin.component.html',
  styles: ``
})
export class PackageAdminComponent implements OnInit {
  companies: CompanyAdmin[] = [];
  columns = [
    { header: 'Empresa', field: 'commercialName' },
    { header: 'Razón Social', field: 'socialReason' },
    { header: 'RUC', field: 'ruc' },
    { header: 'Correo', field: 'email' },
    { header: 'País', field: 'country' },
  ];

  page = 1;
  pageSize = 10;
  total = 0;
  isLoading = false;

  constructor(
    private companyService: CompanyService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadCompanies();
  }

  loadCompanies(): void {
    this.isLoading = true;
    this.companyService.getAllActive().subscribe({
      next: (res) => {
        this.companies = res.dto?.companys || [];
        this.total = this.companies.length;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  goToDetails(company: CompanyAdmin): void {
    this.router.navigate([`/admin/package/company/${company.idCompany}`]);
  }

  onPageChange(newPage: number): void {
    this.page = newPage;
  }
}
